import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { Router } from "@angular/router";
import { AuthenticationService } from "./authentication.service";
// import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';

@Injectable({
  providedIn: "root",
})
export class QsJwtInceptorService implements HttpInterceptor {
  constructor(private router: Router, private authService: AuthenticationService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let org = localStorage.getItem("qs_last_org");
    if (!org) org = "";
    let token = "";
    
    req = req.clone({
      setHeaders: {
        Authorization: "Bearer " + this.authService.accessToken,
        OrganizationId: org,
      },
    });

    // if (req.url.indexOf('connect/token') >= 0) {
    //   let org = this.authService.currentOrganizationValue;
    //   console.log(org);
    //   req = req.clone({
    //     body:req.body + '&organization_id=' + org
    //   });
    // } else {
    //   req = req.clone({
    //     setHeaders: {
    //       Authorization: `Bearer ${this.oidcSecurityService.getAccessToken()}`
    //     }
    //   });
    // }

    return next.handle(req).pipe(
      tap(
        (event) => {},
        (err) => {
          if (err.status === 401) {
            this.router.navigate(["login"]);
          }
        },
        () => {}
      )
    );
  }
}
